/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import { ButtonWithIcon } from '@els/els-react--button';

function DragNode({ node, addToBuilder }) {
  const [{ isDragging }, dragRef] = useDrag(
    {
      type: 'DragNode',
      item: { node, type: 'DragNode' },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    },
    [node]
  );

  return (
    <div className="query-builder-search-section__drag-node" ref={dragRef} draggable>
      <div
        className="query-builder-search-section__drag-node-content"
        onClick={(e) => e.currentTarget === e.target && addToBuilder(node)}
        onKeyDown={(e) => e.currentTarget === e.target && addToBuilder(node)}>
        <ButtonWithIcon
          type="link"
          id="layerIcon"
          linkIconSize="xs"
          sprite={node.canExist && node.children && node.children.length > 1 ? 'MultipleLayers' : 'Layers'}
          onClick={(e) => addToBuilder(node) && e.stopPropagation()}>
          {node.displayName}
        </ButtonWithIcon>
        <ButtonWithIcon
          id={`querybuilder-dragfield-${node.id}`}
          ref={dragRef}
          draggable
          className="cursor-move"
          onClick={(dragE) => dragE.stopPropagation()}
          linkIconSize="xxs"
          iconOnly
          type="borderless"
          aria-grabbed={isDragging}
          sprite="Drag"
          a11y={{ name: 'Drag', description: 'Drag Querylet' }}>
          drag
        </ButtonWithIcon>
      </div>
    </div>
  );
}

DragNode.propTypes = {
  node: PropTypes.object,
  addToBuilder: PropTypes.func,
};

export default DragNode;